import { cn } from '@pickleballinc/ui/lib/utils';

const spinKeyframes = `
@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
`;

interface LoaderProps {
	moduleFor?: string;
	backgroundColor?: string;
	logo?: string;
	label?: string;
	textSize?: string;
	isComponent?: boolean;
	containerClassName?: string;
}

const Loader = ({
	moduleFor = 'Pickleball',
	backgroundColor,
	logo,
	label = 'Loading...',
	isComponent = false,
	textSize = 'text-lg',
	containerClassName = ''
}: LoaderProps) => {
	const computedBackgroundColor = backgroundColor || (moduleFor === 'Tournaments' ? 'bg-blue-800/90' : 'bg-violet-600/90');
	const computedLogo =
		logo ||
		`https://images.pickleball.com${moduleFor === 'Tournaments' ? '/pickleball-app/assets/images/pt-logo-icon-white.svg' : '/global/PB.svg'}`;

	const spinnerSize = isComponent ? 'w-[80px] h-[80px]' : 'w-[120px] h-[120px]';
	const barSize = isComponent ? 'w-[3px] h-4' : 'w-1 h-6';
	const translateDistance = isComponent ? '-30px' : '-40px';
	const logoSize = isComponent ? (moduleFor === 'Tournaments' ? 30 : 20) : moduleFor === 'Tournaments' ? 40 : 30;

	return (
		<>
			<style>{spinKeyframes}</style>
			<div
				className={cn(
					'inset-0 flex items-center justify-center backdrop-blur-sm',
					isComponent ? 'relative rounded-md p-2' : 'fixed z-50',
					computedBackgroundColor,
					containerClassName
				)}
			>
				<div className={cn('flex flex-col items-center', isComponent && 'gap-2')}>
					<div className="relative">
						<div className={cn('relative flex items-center justify-center', spinnerSize)}>
							<div
								className={cn('absolute flex items-center justify-center', spinnerSize)}
								style={{ animation: 'spin 4s linear infinite' }}
							>
								{Array.from({ length: 8 }).map((_, i) => (
									<div
										key={i}
										className={cn('absolute bg-white rounded-full', barSize)}
										style={{ transform: `rotate(${i * 45}deg) translateY(${translateDistance})` }}
									/>
								))}
							</div>
							<img src={computedLogo} alt="Loading" width={logoSize} height={logoSize} />
						</div>
					</div>
					{label ? <p className={`font-semibold text-white ${textSize}`}>{label}</p> : null}
				</div>
			</div>
		</>
	);
};

export default Loader;
